module.exports = "<nv-react-component component=\"TeamsGroupsPanel\"></nv-react-component>";